import type { SupportedAlpha2CountryCode } from '@/lib/utils/localization/getSupportedAlpha2CountryCodes'
import type { MarketExceptionType } from './MarketExceptionTypes'
import { PR } from './Markets/Americas/PR'
import { DO } from './Markets/Americas/DO'
import { US } from './Markets/Americas/US'
import { CA } from './Markets/Americas/CA'
import { NL } from './Markets/Europe/NL'
import { CZ } from './Markets/Europe/CZ'
import { AT } from './Markets/Europe/AT'
import { BE } from './Markets/Europe/BE'
import { DE } from './Markets/Europe/DE'
import { DK } from './Markets/Europe/DK'
import { FR } from './Markets/Europe/FR'
import { HU } from './Markets/Europe/HU'
import { IT } from './Markets/Europe/IT'
import { LU } from './Markets/Europe/LU'
import { NO } from './Markets/Europe/NO'
import { PL } from './Markets/Europe/PL'
import { IE } from './Markets/Europe/IE'
import { ES } from './Markets/Europe/ES'
import { SE } from './Markets/Europe/SE'
import { MX } from './Markets/Americas/MX'
import { CO } from './Markets/Americas/CO'
import { GB } from './Markets/Europe/GB'
import { CH } from './Markets/Europe/CH'
import { SI } from './Markets/Europe/SI'
import { SK } from './Markets/Europe/SK'
import { RO } from './Markets/Europe/RO'
import { PT } from './Markets/Europe/PT'
import { MT } from './Markets/Europe/MT'
import { LT } from './Markets/Europe/LT'
import { LV } from './Markets/Europe/LV'
import { IS } from './Markets/Europe/IS'
import { GR } from './Markets/Europe/GR'
import { EE } from './Markets/Europe/EE'
import { CY } from './Markets/Europe/CY'
import { HR } from './Markets/Europe/HR'
import { BG } from './Markets/Europe/BG'
import { FI } from './Markets/Europe/FI'
import { PH } from './Markets/Asia/PH'
import { OM } from './Markets/MiddleEast/OM'
import { MA } from './Markets/MiddleEast/MA'
import { JO } from './Markets/MiddleEast/JO'
import { JP } from './Markets/Asia/JP'

// TypeScript will enforce that ALL SupportedAlpha2CountryCode values have configs
// If you add a new country to supportedMarkets, TypeScript will error until you add its config
const marketExceptions: {
  [K in SupportedAlpha2CountryCode]: MarketExceptionType
} = {
  AT,
  BE,
  CH,
  DE,
  DK,
  FR,
  HU,
  IT,
  LU,
  NO,
  PL,
  IE,
  ES,
  SE,
  CA,
  GB,
  PR,
  DO,
  US,
  NL,
  CZ,
  MX,
  CO,
  SI,
  SK,
  RO,
  PT,
  MT,
  LT,
  LV,
  IS,
  GR,
  EE,
  CY,
  HR,
  BG,
  FI,
  PH,
  OM,
  MA,
  JP,
  JO,
}

// IMPORTANT: Do not export marketExceptions directly to prevent bypassing common defaults
// All market config access must go through getMarketConfig to ensure common defaults are applied

export { Common } from './Markets/Common/Common'

// Internal export for getMarketConfig utility only - DO NOT USE DIRECTLY
/** @internal - This export is only for the getMarketConfig utility. Use getMarketConfig() instead. */
export const internalMarketExceptions = marketExceptions
